/**
 * Who approved, said once (backlog ebc9aae4): "Hai in chat" for an approval
 * given to the agent, "htran" for one in the app (the app is the default and
 * goes unsaid). approverName is the server's one name for the person; an
 * agent's own approvedBy text ("Site owner (approved in chat)") is the
 * fallback for rows from before it existed.
 */
export interface ApproverSource {
  approvedBy?: string | null;
  approverName?: string | null;
  via?: string | null;
}

export const approverOf = (a: ApproverSource) => a.approverName || a.approvedBy || '';

export const approverPhrase = (a: ApproverSource) =>
  `${approverOf(a)}${a.via === 'mcp' ? ' in chat' : ''}`;

/**
 * The publish a bring-in records (articleAdopt.js's note). Its stored override
 * and note are for the record; the histories say "Brought into TinyCMS ·
 * v1 approved" instead (Prototype, backlog 99cc2979).
 */
export const isBroughtIn = (a: {
  action?: string | null;
  outcome?: string | null;
  note?: string | null;
}) =>
  a.outcome === 'accepted' &&
  a.action === 'publish' &&
  /^Brought under TinyCMS/i.test(a.note || '');
